// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/chunks/" + chunkId + ".a6857322-83fa-41f3-8a0c-2e9488d82aac.js";
};